<template>
  <div id="page-wrapper">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="page-header">
            <i class="fa fa-book fa-fw"></i>Credenciamentos
          </h1>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div>
            <ul class="nav nav-tabs" role="tablist">
              <li role="presentation">
                <a
                  href="#solicitacoes"
                  aria-controls="solicitacoes"
                  role="tab"
                  data-js="novas"
                  data-toggle="tab"
                >
                  <i class="fa fa-sign-in text-primary fa-2x"></i>
                  <span class="text-primary">Novas Solicitações</span>
                </a>
              </li>
              <li role="presentation">
                <a
                  href="#emAnalise"
                  aria-controls="emAnalise"
                  role="tab"
                  data-js="em-analise"
                  data-toggle="tab"
                >
                  <i class="fa fa-hourglass-start text-warning fa-2x"></i>
                  <span class="text-warning">Em Análise</span>
                </a>
              </li>
              <li role="presentation">
                <a
                  href="#liberadas"
                  aria-controls="liberadas"
                  role="tab"
                  data-js="liberadas"
                  data-toggle="tab"
                >
                  <i class="fa fa-check text-success fa-2x"></i>
                  <span class="text-success">Liberadas</span>
                </a>
              </li>
              <li role="presentation">
                <a
                  href="#bloqueadas"
                  aria-controls="bloqueadas"
                  data-js="bloqueadas"
                  role="tab"
                  data-toggle="tab"
                >
                  <i class="fa fa-times text-danger fa-2x"></i>
                  <span class="text-danger">Bloqueadas</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="tab-content">
            <div role="tabpanel" class="tab-pane" id="solicitacoes">
              <br />
              <table class="table table-bordered table-striped table-hover"
                v-if="accreditation.state == undefined">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nome da Empresa</th>
                    <th>Nome da Atividade</th>
                    <th>Documento</th>
                    <th>Data de criação</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="accreditation in filtred"
                    :key="accreditation.id"
                    @mouseover="showByIndex = accreditation.id"
                    @mouseout="showByIndex = null"
                  >
                    <td>{{ accreditation.id }}</td>
                    <td>{{ accreditation.person.name }}</td>
                    <td>{{ accreditation.activity.name }}</td>
                    <td>{{ accreditation.created | formatDate }}</td>
                    <td>
                      <span v-visible="showByIndex === accreditation.id">
                        <a
                          class="btn btn-sm btn-primary"
                          @click="
                            showModal = 1;
                            show = accreditation.id;
                          "
                          ><i class="fa fa-eye fa-fw"></i
                        ></a>
                      </span>
                    </td>
                    <Modal v-if="showModal === 1 && show === accreditation.id">
                      <i slot="close" @click="showModal = null">&times;</i>
                      <h2 slot="header">
                        <i class="fa fa-eye fa-fw"></i> Detalhes
                      </h2>                      
                      <div slot="body">
                        <table
                          class="table table-bordered table-striped table-hover"
                        >
                          <thead>
                            <tr>
                              <th>Id</th>
                              <th>Nome da Empresa</th>
                              <th>Nome da Atividade</th>
                              <th>Data de criação</th>
                              <th>Status</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{{ accreditation.id }}</td>
                              <td>{{ accreditation.person.name }}</td>
                              <td>{{ accreditation.activity.name }}</td>
                              <td>
                                {{ accreditation.created | formatDate }}
                              </td>
                              <td>
                                <div
                                  v-if="state === 'emAnalise'"
                                  class="label label-warning"
                                >
                                  Em analise
                                </div>
                                <div
                                  v-else-if="state === 'liberado'"
                                  class="label label-success"
                                >
                                  Liberado
                                </div>
                                <div
                                  v-else-if="state === 'bloqueado'"
                                  class="label label-danger"
                                >
                                  Bloqueado
                                </div>
                              </td>
                              <td>
                                <a
                                  class="btn btn-sm btn-primary"
                                  href="#/admin/persons"
                                >
                                  <i class="fa fa-pencil fa-fw"></i>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <label>Status</label>
                        <select class="form-control" v-model="state">
                          <option value="emAnalise">em Analise</option>
                          <option value="liberado">liberado</option>
                          <option value="bloqueado">bloqueado</option>
                        </select>
                      </div>
                      <div slot="footer">
                        <button
                          type="submit"
                          class="btn btn-primary"
                          @click="showModal = null"
                          v-on:click.once="sendState"
                        >
                          Confirmar
                        </button>
                        <button
                          class="btn btn-default"
                          @click="showModal = null"
                        >
                          fechar
                        </button>
                      </div>
                    </Modal>
                  </tr>
                </tbody>
              </table>
            </div>

            <div role="tabpanel" class="tab-pane" id="emAnalise">
              <br />
              <table
                class="table table-bordered table-striped table-hover"
                v-if="accreditation.status === 'emAnalise'"
              >
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nome da Empresa</th>
                    <th>Nome da Atividade</th>
                    <th>Documento</th>
                    <th>Data de criação</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="accreditation in filtred"
                    :key="accreditation.id"
                    @mouseover="showByIndex = accreditation.id"
                    @mouseout="showByIndex = null"
                  >
                    <td>{{ accreditation.id }}</td>
                    <td>{{ accreditation.person.name }}</td>
                    <td>{{ accreditation.activity.name }}</td>
                    <td>{{ accreditation.created | formatDate }}</td>
                    <td>
                      <span v-visible="showByIndex === accreditation.id">
                        <a
                          class="btn btn-sm btn-primary"
                          @click="
                            showModal = 2;
                            show = accreditation.id;
                          "
                          ><i class="fa fa-eye fa-fw"></i
                        ></a>
                      </span>
                    </td>
                    <Modal v-if="showModal === 2 && show === accreditation.id">
                      <i slot="close" @click="showModal = null">&times;</i>
                      <h2 slot="header">
                        <i class="fa fa-eye fa-fw"></i> Detalhes
                      </h2>
                      <div slot="body">
                        <table
                          class="table table-bordered table-striped table-hover"
                        >
                          <thead>
                            <tr>
                              <th>Id</th>
                              <th>Nome da Empresa</th>
                              <th>Nome da Atividade</th>
                              <th>Data de criação</th>
                              <th>Status</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{{ accreditation.id }}</td>
                              <td>{{ accreditation.person.name }}</td>
                              <td>{{ accreditation.activity.name }}</td>
                              <td>
                                {{ accreditation.created | formatDate }}
                              </td>
                              <td>
                                <div
                                  v-if="state === 'emAnalise'"
                                  class="label label-warning"
                                >
                                  Em analise
                                </div>
                                <div
                                  v-else-if="state === 'liberado'"
                                  class="label label-success"
                                >
                                  Liberado
                                </div>
                                <div
                                  v-else-if="state === 'bloqueado'"
                                  class="label label-danger"
                                >
                                  Bloqueado
                                </div>
                              </td>
                              <td>
                                <a
                                  class="btn btn-sm btn-primary"
                                  href="#/admin/persons"
                                >
                                  <i class="fa fa-pencil fa-fw"></i>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <label>Status</label>
                        <select class="form-control" v-model="state">
                          <option value="emAnalise">em Analise</option>
                          <option value="liberado">liberado</option>
                          <option value="bloqueado">bloqueado</option>
                        </select>
                      </div>
                      <div slot="footer">
                        <button
                          type="submit"
                          class="btn btn-primary"
                          @click="showModal = null"
                          v-on:click.once="sendState"
                        >
                          Confirmar
                        </button>
                        <button
                          class="btn btn-default"
                          @click="showModal = null"
                        >
                          fechar
                        </button>
                      </div>
                    </Modal>
                  </tr>
                </tbody>
              </table>
            </div>

            <div role="tabpanel" class="tab-pane" id="liberadas">
              <br />
              <table
                class="table table-bordered table-striped table-hover"
                v-if="accreditation.status === 'liberado'"
              >
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nome da Empresa</th>
                    <th>Nome da Atividade</th>
                    <th>Documento</th>
                    <th>Data de criação</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="accreditation in filtred"
                    :key="accreditation.id"
                    @mouseover="showByIndex = accreditation.id"
                    @mouseout="showByIndex = null"
                  >
                    <td>{{ accreditation.id }}</td>
                    <td>{{ accreditation.person.name }}</td>
                    <td>{{ accreditation.activity.name }}</td>
                    <td>{{ accreditation.created | formatDate }}</td>
                    <td>
                      <span v-visible="showByIndex === accreditation.id">
                        <a
                          class="btn btn-sm btn-primary"
                          @click="
                            showModal = 3;
                            show = accreditation.id;
                          "
                          ><i class="fa fa-eye fa-fw"></i
                        ></a>
                      </span>
                    </td>
                    <Modal v-if="showModal === 3 && show === accreditation.id">
                      <i slot="close" @click="showModal = null">&times;</i>
                      <h2 slot="header">
                        <i class="fa fa-eye fa-fw"></i> Detalhes
                      </h2>
                      <div slot="body">
                        <table
                          class="table table-bordered table-striped table-hover"
                        >
                          <thead>
                            <tr>
                              <th>Id</th>
                              <th>Nome da Empresa</th>
                              <th>Nome da Atividade</th>
                              <th>Data de criação</th>
                              <th>Status</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{{ accreditation.id }}</td>
                              <td>{{ accreditation.person.name }}</td>
                              <td>{{ accreditation.activity.name }}</td>
                              <td>
                                {{ accreditation.created | formatDate }}
                              </td>
                              <td>
                                <div
                                  v-if="state === 'emAnalise'"
                                  class="label label-warning"
                                >
                                  Em analise
                                </div>
                                <div
                                  v-else-if="state === 'liberado'"
                                  class="label label-success"
                                >
                                  Liberado
                                </div>
                                <div
                                  v-else-if="state === 'bloqueado'"
                                  class="label label-danger"
                                >
                                  Bloqueado
                                </div>
                              </td>
                              <td>
                                <a
                                  class="btn btn-sm btn-primary"
                                  href="#/admin/persons"
                                >
                                  <i class="fa fa-pencil fa-fw"></i>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <label>Status</label>
                        <select class="form-control" v-model="state">
                          <option value="emAnalise">em Analise</option>
                          <option value="liberado">liberado</option>
                          <option value="bloqueado">bloqueado</option>
                        </select>
                      </div>
                      <div slot="footer">
                        <button
                          type="submit"
                          class="btn btn-primary"
                          @click="showModal = null"
                          v-on:click.once="sendState"
                        >
                          Confirmar
                        </button>
                        <button
                          class="btn btn-default"
                          @click="showModal = null"
                        >
                          fechar
                        </button>
                      </div>
                    </Modal>
                  </tr>
                </tbody>
              </table>
            </div>

            <div role="tabpanel" class="tab-pane" id="bloqueadas">
              <br />
              <table
                class="table table-bordered table-striped table-hover"
                v-if="accreditation.status === 'bloqueado'"
              >
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Nome da Empresa</th>
                    <th>Nome da Atividade</th>
                    <th>Documento</th>
                    <th>Data de criação</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="accreditation in filtred"
                    :key="accreditation.id"
                    @mouseover="showByIndex = accreditation.id"
                    @mouseout="showByIndex = null"
                  >
                    <td>{{ accreditation.id }}</td>
                    <td>{{ accreditation.person.name }}</td>
                    <td>{{ accreditation.activity.name }}</td>
                    <td>{{ accreditation.created | formatDate }}</td>
                    <td>
                      <span v-visible="showByIndex === accreditation.id">
                        <a
                          class="btn btn-sm btn-primary"
                          @click="
                            showModal = 4;
                            show = accreditation.id;
                          "
                          ><i class="fa fa-eye fa-fw"></i
                        ></a>
                      </span>
                    </td>
                    <Modal v-if="showModal === 4 && show === accreditation.id">
                      <i slot="close" @click="showModal = null">&times;</i>
                      <h2 slot="header">
                        <i class="fa fa-eye fa-fw"></i> Detalhes
                      </h2>
                      <div slot="body">
                        <table
                          class="table table-bordered table-striped table-hover"
                        >
                          <thead>
                            <tr>
                              <th>Id</th>
                              <th>Nome da Empresa</th>
                              <th>Nome da Atividade</th>
                              <th>Data de criação</th>
                              <th>Status</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{{ accreditation.id }}</td>
                              <td>{{ accreditation.person.name }}</td>
                              <td>{{ accreditation.activity.name }}</td>
                              <td>
                                {{ accreditation.created | formatDate }}
                              </td>
                              <td>
                                <div
                                  v-if="state === 'emAnalise'"
                                  class="label label-warning"
                                >
                                  Em analise
                                </div>
                                <div
                                  v-else-if="state === 'liberado'"
                                  class="label label-success"
                                >
                                  Liberado
                                </div>
                                <div
                                  v-else-if="state === 'bloqueado'"
                                  class="label label-danger"
                                >
                                  Bloqueado
                                </div>
                              </td>
                              <td>
                                <a
                                  class="btn btn-sm btn-primary"
                                  href="#/admin/persons"
                                >
                                  <i class="fa fa-pencil fa-fw"></i>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <label>Status</label>
                        <select class="form-control" v-model="state">
                          <option value="emAnalise">em Analise</option>
                          <option value="liberado">liberado</option>
                          <option value="bloqueado">bloqueado</option>
                        </select>
                      </div>
                      <div slot="footer">
                        <button
                          type="submit"
                          class="btn btn-primary"
                          @click="showModal = null"
                          v-on:click.once="sendState"
                        >
                          Confirmar
                        </button>
                        <button
                          class="btn btn-default"
                          @click="showModal = null"
                        >
                          fechar
                        </button>
                      </div>
                    </Modal>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import storage from "../../mixins/storage";
import Modal from "../../components/ui-elements/Modal.vue";
export default {
  name: "MyAccreditations",
  inject: ["loading"],
  components: { Modal },
  data() {
    return {
      showByIndex: null,
      document: {},
      documents: [],
      showModal: null,
      show: null,
      type: null,
      accreditation: {},
      accreditations: [],
      search: "",
    };
  },
  mounted() {
    let abas = {};
    this.type = this.$route.query.type;
    abas.novas = document.querySelector('[data-js="novas"]');
    abas.emAnalise = document.querySelector('[data-js="em-analise"]');
    abas.liberadas = document.querySelector('[data-js="liberadas"]');
    abas.bloqueadas = document.querySelector('[data-js="bloqueadas"]');

    abas[this.type].click();

    this.loading.value = true;
    this.$http
      .get(`/auth/info/${storage.methods.getToken()}`)
      .then((response) => {
        this.user = response.data;
        this.$http.get("my-accreditation").then((response) => {
          this.accreditations = response.data;
        });
      });
    setTimeout(() => (this.loading.value = false), 1000);
  },
  methods: {
    sendState() {
      this.loading.value = true;
      this.accreditation.state = this.state;
      this.$http.post("my-accreditation", this.accreditation).then((response) => {
        this.accreditation = {}
        this.state = "";
        this.accreditations.push(response.data);
      });
      setTimeout(() => (this.loading.value = false), 1000);
    },

  },
  computed: {
    filtred() {
      const search = this.search.toLowerCase().trim();
      let result = [];

      if (!search) {
        result = this.accreditations;
      }

      result = this.accreditations.filter((a) => {
        const field = a.name || "";

        return field.toLowerCase().indexOf(search) > -1;
      });

      return result.sort((a, b) => b.id - a.id);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/pages/MyAccreditations.vue